export const getIsInitialDataSet = (state) => {
  return state.initialDataSet;
};
